// extracted by mini-css-extract-plugin
export default {"container":"fullpage_container__2mVYf"};